import { Box, Grid, Typography } from "@material-ui/core";
import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import { getDisplayAmount } from "./ManageSubscriptionForm";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    creditBox: {
      marginTop: "25px",
    },
    productText: {
      color: theme.palette.dark.main,
      fontWeight: "bold",
      justifyContent: "left",
      display: "flex",
    },
    totalText: {
      color: theme.palette.dark.main,
      fontWeight: "bold",
      justifyContent: "right",
      display: "flex",
    },
  })
);

export default function AccountCreditLayout(props: IProps) {
  const classes = useStyles();
  const { t } = useTranslation();
  const { amountDue, country } = props;

  return (
    <React.Fragment>
      <Box className={classes.creditBox}>
        <Grid container>
          <Grid item xs={8}>
            <Typography className={classes.productText}>
              {t("total_credit")}
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography className={classes.totalText}>
              {getDisplayAmount(amountDue / 100, country)}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </React.Fragment>
  );
}

interface IProps {
  amountDue: number;
  country: string;
}
